import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Chip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { IS_PRODUCTION } from "@/constants/env";
export const ProfileIsStaffChipFragment = graphql(`
  fragment ProfileIsStaffChip on Profile {
    isStaff
  }
`);
export function ProfileIsStaffChip(t0) {
  const $ = _c(5);
  const {
    profile: profileKey,
    chipVariant
  } = t0;
  const profile = readFragment(ProfileIsStaffChipFragment, profileKey);
  const t = useTranslations("ProfileIsStaffChip");
  if (!profile.isStaff || IS_PRODUCTION) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== chipVariant || $[3] !== t1) {
    t2 = <Chip variant={chipVariant}>{t1}</Chip>;
    $[2] = chipVariant;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}